import React, { useState, useContext } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import AccreditationInput from "../../AccreditationInput/AccreditationInput";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";
import { validateString } from "../../../utils/validateString";
import { apiRoutes } from "../../../utils/apiRoutes";
import { createData, updateData, deleteData } from "../../../utils/methods";
import { useNavigate } from "react-router-dom";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { trimValues } from "../../../utils/trimValues";
import { useAlert } from "../../../utils/AlertContext";
import HistoryPanel from "../../HistoryPanel/HistoryPanel";
import EditModalShell from "./EditModalShell";
import ConfirmationModal from "./ConfirmationModal";
import useEnterKeySubmit from "../../../hooks/useEnterKeySubmit";
import { diffChangedFields } from "../../../utils/diffChangedFields";

// Build-time literal (unlike apiRoutes) so Terser can prove the History
// branch below is dead code on tiers other than Third — genuinely absent
// from the compiled bundle, not just unrendered. See AddPerson.jsx.
const TIER = process.env.REACT_APP_MODE;

const AddGroup = ({
  onCloseClick,
  object,
  editing,
  handleAddData,
  handleUpdateData,
  handleDeleteData,
}) => {
  const [groupObject, setGroupObject] = useState(
    object
      ? object
      : {
          naziv: "",
          skracenica: "",
          opis: "",
          ip_opseg: [],
          lat: 0,
          lng: 0,
          administrator: false,
          moderator: false,
          verifikator: false,
          obezbedjenje: false,
          info_pult: false,
          stampa: false,
        },
  );

  console.log("objekat", groupObject);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);

  const validateAllFields = () => {
    const fieldsToValidate = ["naziv", "lat", "lng"];
    let hasError = false;

    fieldsToValidate.forEach((field) => {
      const value = groupObject[field];
      let err = false;
      console.log(value);
      if (field === "lat") {
        err = validateString(value, "lat");
        console.log("lat err", err);
      } else if (field === "lng") {
        err = validateString(value, "lng");
      }
      if ((field === "naziv" && !value) || err) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: true,
        }));
        hasError = true;
      }
    });

    return !hasError;
  };

  console.log("greske", errors);

  const setInputValue = (key, value) => {
    setGroupObject((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleAddClick = async () => {
    setErrors();
    const isValid = validateAllFields();

    if (!isValid) {
      console.log("Postoje greške u formi.");
      return;
    }

    setIsLoading(true);
    const sendData = trimValues(groupObject);

    try {
      const result = await createData(
        apiRoutes.addGroup,
        sendData,
        showAlert,
        navigate,
        t,
      );

      if (!result) return;

      console.log("Podaci su uspešno sačuvani:", result.data);
      handleAddData({ ...sendData, id: result.data?.id });
      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveClick = async () => {
    setErrors();
    const isValid = validateAllFields();
    if (!isValid) {
      console.log("Postoje greške u formi.");
      return;
    }

    const id = object.id;
    const route = apiRoutes.updateGroup.replace(":groupId", id);

    const podaciZaSlanje = { ...groupObject };
    const objekatPromena = diffChangedFields(podaciZaSlanje, groupObject.old_group, ["old_group"]);
    console.log("promenjena polja 1", objekatPromena);

    delete podaciZaSlanje.id;
    const sendData = trimValues(objekatPromena);

    setIsLoading(true);

    try {
      const result = await updateData(route, sendData, showAlert, navigate, t);
      if (!result) return;

      console.log("Podaci su uspešno sačuvani:", result.data);
      handleUpdateData({ ...sendData, id: result.data?.id });
      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const { t } = useContext(TranslationsContext);

  const handleDeleteClick = async () => {
    const route = apiRoutes.deleteGroup.replace(":groupId", object.id);
    setIsLoading(true);
    try {
      const result = await deleteData(route, null, showAlert, navigate, t);
      if (!result) return;

      handleDeleteData?.(object.id);
      showAlert(t("SUCCESSFULLY_DELETED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
      setIsConfirmDeleteOpen(false);
    }
  };

  useEnterKeySubmit(editing ? handleSaveClick : handleAddClick);

  return (
    <>
    <EditModalShell
      isLoading={isLoading}
      t={t}
      className="edit-modal-shell-side-top"
      headerInfo={
        <p className="inria-sans-400 font-24 modal-title">
          {editing ? t("EDIT_GROUP_TITLE") : t("ADD_GROUP_TITLE")}
        </p>
      }
      onSave={editing ? handleSaveClick : handleAddClick}
      onClose={onCloseClick}
      onDelete={editing ? () => setIsConfirmDeleteOpen(true) : undefined}
      sidePanel={
        editing && TIER === "third" ? (
          <HistoryPanel tabela="grupe" redId={object?.id} />
        ) : null
      }
    >
      <div className="flex-direction-column gap-24 width-100 modal-content">
        <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
          <AccreditationInput
            className="modal-input"
            label={t("NAME_1")}
            setInputValue={(value) => setInputValue("naziv", value)}
            value={groupObject.naziv}
            error={errors?.naziv}
            required={true}
          />
          <AccreditationInput
            className="modal-input"
            label={t("IDENTIFIER")}
            setInputValue={(value) => setInputValue("skracenica", value)}
            value={groupObject.skracenica}
          />
        </div>
        <div className="width-100">
          <AccreditationInput
            className="modal-input"
            label={t("DESCRIPTION")}
            type="text-area"
            setInputValue={(value) => setInputValue("opis", value)}
            value={groupObject.opis}
          />
        </div>
        <div className="width-100">
          <AccreditationInput
            type="tag"
            valueType="ip"
            tags={groupObject.ip_opseg}
            onTagsChange={(newTags) => setInputValue("ip_opseg", newTags)}
            placeholder={t("ADD_IP_PLH")}
            label={t("IP_RANGE")}
            variant="ip"
          />
        </div>
        <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
          <AccreditationInput
            label={t("LAT")}
            className="modal-input"
            setInputValue={(value) => setInputValue("lat", Number(value))}
            value={groupObject.lat}
            type="lat"
            error={errors?.lat}
          />
          <AccreditationInput
            label={t("LNG")}
            className="modal-input"
            setInputValue={(value) => setInputValue("lng", Number(value))}
            value={groupObject.lng}
            type="lng"
            error={errors?.lng}
          />
        </div>
        <div className="flex-direction-column gap-12">
          <ToggleSwitch
            label={t("ADMINISTRATOR")}
            setIsOn={(value) => setInputValue("administrator", value)}
            value={groupObject.administrator}
          />
          <ToggleSwitch
            label={t("MODERATOR")}
            setIsOn={(value) => setInputValue("moderator", value)}
            value={groupObject.moderator}
          />
          <ToggleSwitch
            label={t("VERIFIER")}
            setIsOn={(value) => setInputValue("verifikator", value)}
            value={groupObject.verifikator}
          />
          <ToggleSwitch
            label={t("SECURITY")}
            setIsOn={(value) => setInputValue("obezbedjenje", value)}
            value={groupObject.obezbedjenje}
          />
          <ToggleSwitch
            label={t("INFO_DESK")}
            setIsOn={(value) => setInputValue("info_pult", value)}
            value={groupObject.info_pult}
          />
          <ToggleSwitch
            label={t("PRESS")}
            setIsOn={(value) => setInputValue("stampa", value)}
            value={groupObject.stampa}
          />
        </div>
      </div>
    </EditModalShell>
    {isConfirmDeleteOpen && (
      <ConfirmationModal
        handleDeclineClick={() => setIsConfirmDeleteOpen(false)}
        handleConfirmClick={() => handleDeleteClick()}
        term={groupObject.naziv}
      />
    )}
    </>
  );
};
export default AddGroup;
